/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6f8ce691"]'><cube-button outline :loading="(loading)" @_click="clickBtn">加载按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6f8ce691"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6f8ce691"}
  /** script content **/
  require("./btn-loading.mpx.js?isComponent&outputPath=components%2Fbtn-loading6f8ce691%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-loading.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-loading6f8ce691%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6f8ce691"],
    ctorType: "component",
    outputPath: "components/btn-loading6f8ce691/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>